module.exports = __webpack_public_path__ + "img/psd.7e4912b2.svg";